import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Input, FormLabel } from '@getro/rombo';
import { Box } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { convertFromCents } from 'helpers/money';
import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useSalaryFilter } from './useSalaryFilter';

export const SalaryFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, currencyOptions, periodOptions } = useSalaryFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{
        amountMin: value?.compensationAmountMinCents ? convertFromCents(value.compensationAmountMinCents) : '',
        currency: value?.currency
          ? currencyOptions.find((c) => c.value === value.currency)
          : currencyOptions.find((c) => c.value === 'USD'),
        period: value?.period ? periodOptions.find((p) => p.value === value.period) : periodOptions[0],
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box width="100%">
            <FormLabel>Minimum salary</FormLabel>
            <Field
              name="amountMin"
              placeholder="0"
              size="small"
              component={Input}
              // Debounce the setFilters call to avoid excessive updates
              onChange={React.useMemo(() => {
                let timeout;
                return (e) => {
                  const valueToSet = {
                    ...value,
                    compensationAmountMinCents: e.target.value,
                  };
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    setFilters(valueToSet);
                  }, 300);
                };
              }, [setFilters, value])}
            />
          </Box>
          <Field
            name="currency"
            component={FormExtraOptions}
            options={currencyOptions}
            data-testid="currency-select"
            anchorToBody
          />
          <Field
            name="period"
            component={FormExtraOptions}
            options={periodOptions}
            data-testid="period-select"
            anchorToBody
          />
        </div>
      </Form>
    </Formik>
  );
};

SalaryFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

SalaryFilter.defaultProps = {
  value: null,
};
